var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-layout',{staticClass:"pa-0"},[_c('opening-image',{staticClass:"pa-0"})],1),_c('quote'),_c('partners'),_c('sponsors')],1)}
var staticRenderFns = []

export { render, staticRenderFns }